export default {
	project_name: 'CRM Play',
	see_the_full_ranking: 'Ver mais',
	company_agency: 'Loja',
}
